import { render, staticRenderFns } from "./EditDate.vue?vue&type=template&id=8961c9d2&"
import script from "./EditDate.vue?vue&type=script&lang=js&"
export * from "./EditDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8961c9d2')) {
      api.createRecord('8961c9d2', component.options)
    } else {
      api.reload('8961c9d2', component.options)
    }
    module.hot.accept("./EditDate.vue?vue&type=template&id=8961c9d2&", function () {
      api.rerender('8961c9d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Agenda/EditDate.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Agenda/EditDate.vue
// module id = 421
// module chunks = 0